var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoDivergenciaFiscal01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_911_1_",
    d: "M8.7,18.7H4c-0.3,0-0.6,0.3-0.6,0.6V24c0,0.3,0.3,0.6,0.6,0.6h4.7c0.3,0,0.6-0.3,0.6-0.6v-4.7 C9.3,19,9,18.7,8.7,18.7z M8.1,23.4H4.6v-3.5h3.5V23.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_912_1_",
    d: "M8.7,26.3H4c-0.3,0-0.6,0.3-0.6,0.6v4.7c0,0.3,0.3,0.6,0.6,0.6h4.7c0.3,0,0.6-0.3,0.6-0.6v-4.7 C9.3,26.6,9,26.3,8.7,26.3z M8.1,31H4.6v-3.5h3.5V31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_913_1_",
    d: "M33,2.4c-0.2-0.2-0.6-0.2-0.8,0c0,0,0,0,0,0l-3.7,3.7l-5.4-5.4c-0.1-0.1-0.3-0.2-0.4-0.2H1.1 c-0.3,0-0.6,0.3-0.6,0.6c0,0,0,0,0,0v33.9c0,0.3,0.3,0.6,0.6,0.6h27.4c0.3,0,0.6-0.3,0.6-0.6V11.8l6.3-6.3c0.2-0.2,0.2-0.6,0-0.8 c0,0,0,0,0,0L33,2.4z M27.9,34.4H1.7V1.7h20.8l4.7,4.7h-3.8V3.4h-1.2v3.5c0,0.3,0.3,0.6,0.6,0.6h4.4L13.5,21.1 c-0.1,0.1-0.1,0.1-0.1,0.2l-1.2,3.5c-0.1,0.3,0.1,0.6,0.4,0.7c0.1,0,0.2,0,0.4,0l3.5-1.2c0.1,0,0.2-0.1,0.2-0.1L27.9,13L27.9,34.4z  M14.2,22.6l1,1l-1.5,0.5L14.2,22.6z M16.3,23l-1.5-1.5L32.6,3.6l1.5,1.5L16.3,23z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_914_1_",
    d: "M25.6,32h1.2v1.2h-1.2V32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_915_1_",
    d: "M23.3,32h1.2v1.2h-1.2V32z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_916_1_",
    d: "M20.9,32h1.2v1.2h-1.2V32z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1358",
    transform: "translate(1266.682 453.115)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_228",
    x: -1260.9,
    y: -433.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -64.0792 -1017.5804)",
    width: 1,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_229",
    x: -1262,
    y: -431.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -64.0798 -1017.5804)",
    width: 3.4,
    height: 1
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_911-2",
    d: "M8.7,11.2H4c-0.3,0-0.6,0.3-0.6,0.6v4.7c0,0.3,0.3,0.6,0.6,0.6h4.7c0.3,0,0.6-0.3,0.6-0.6v-4.7 C9.3,11.5,9,11.2,8.7,11.2z M8.1,15.9H4.6v-3.5h3.5V15.9z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1359",
    transform: "translate(1266.682 444.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_230",
    x: -1260.9,
    y: -432.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -64.8295 -1017.2697)",
    width: 1,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_231",
    x: -1262,
    y: -430.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -64.8302 -1017.2697)",
    width: 3.4,
    height: 1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_911-3",
    d: "M8.7,3.7H4C3.7,3.7,3.4,4,3.4,4.3V9c0,0.3,0.3,0.6,0.6,0.6h4.7C9,9.6,9.3,9.3,9.3,9V4.3 C9.3,4,9,3.7,8.7,3.7z M8.1,8.4H4.6V4.9h3.5V8.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1360",
    transform: "translate(1266.682 436.027)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_232",
    x: -1260.9,
    y: -431,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -65.5798 -1016.9589)",
    width: 1,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_233",
    x: -1262,
    y: -429.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -65.5805 -1016.9589)",
    width: 3.4,
    height: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1361",
    transform: "translate(1266.682 461.733)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_234",
    x: -1260.9,
    y: -434.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -63.3223 -1017.8939)",
    width: 1,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_235",
    x: -1262,
    y: -433,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -63.323 -1017.894)",
    width: 3.4,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDivergenciaFiscal01);
export default __webpack_public_path__ + "static/media/ico-divergencia-fiscal-01.3da5b7198574c1b02d1a4b8b01c7274f.svg";
export { ForwardRef as ReactComponent };